import { Component, h } from 'preact';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import FramesChild from './components/FramesChild';

// internal
import getJSON from './utils/get-json';
import {
  determineContestTitleYourRaces,
  countdown,
  getOfficeSlug,
  getParty,
} from './election-utils';
import { RESULTS_IN_USE } from './endpoints';
import { LENGTH_OF_CHECK_INTERVAL } from './constants';
import { PreactHTMLConverter } from 'preact-html-converter';

import context from '../../data/text.json';

const converter = PreactHTMLConverter();

class App extends Component<{ selectedContests: string[] }, {}> {
  constructor() {
    super();

    this.state = { contests: [] };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    const selectedContests = this.props.selectedContests;

    getJSON(RESULTS_IN_USE).then(contests => {
      const activeContests = contests.filter(contest => {
        const slug = `${contest.office_slug}`;

        return selectedContests.indexOf(slug) >= 0;
      });

      this.setState({ contests: activeContests }, this.startTimer);
    });
  }

  startTimer() {
    this.timer = window.setTimeout(this.fetchData, LENGTH_OF_CHECK_INTERVAL);
  }

  clearTimer() {
    window.clearTimeout(this.timer);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  componentDidUpdate() {
    const length = Math.ceil(LENGTH_OF_CHECK_INTERVAL / 60000);
    countdown(length); //where n is the number of minutes required.
  }

  render() {
    const { contests } = this.state;
    const { annotations, embedType } = this.props;

    return (
      <FramesChild class="embed">
        <div class="status-current">
          <h3 class="article-subsubheader copy">
            {converter.convert(context.status_of_race[0].value.text)}
          </h3>

          <p class="copy">
            {converter.convert(context.status_of_race[1].value)}
          </p>
          <p class="copy">
            {converter.convert(context.status_of_race_embed[0].value)}
          </p>
        </div>
        <div class="seat__races">
          {contests.map(contest => (
            <Contest
              key={contest.id}
              contest={contest}
              tableHeader={CandidateRow.Header}
              columnCount={CandidateRow.columnCount}
              contestTitle={determineContestTitleYourRaces(
                contests.filter(
                  item => item.office_slug === contest.office_slug
                )[0]
              )}
              annotations={annotations.filter(
                item =>
                  getOfficeSlug(item.type) === contest.office_slug &&
                  getParty(item.type) === contest.party
              )}
              embedType={embedType}
              renderCandidate={(
                candidate,
                idx,
                viewAllCandidates,
                { totalVotes }
              ) => {
                return (
                  <CandidateRow
                    key={candidate.id}
                    ballotName={candidate.name}
                    candidateId={candidate.id}
                    isIncumbent={candidate.is_incumbent}
                    isWinner={candidate.is_winner}
                    isViewable={viewAllCandidates || idx < 3}
                    party={candidate.party}
                    totalVotesInContest={totalVotes}
                    votes={candidate.votes}
                  />
                );
              }}
            />
          ))}
        </div>
      </FramesChild>
    );
  }
}

export default App;
